/**
 * Error Info
 * @class Error Info
 * @property {string} error error state
 * @property {string} message 오류 메시지
 * @property {string} path api path
 * @property {string} status status
 * @property {string} timestamp 오류 시간
 */
export class ErrorInfo {
  constructor(props) {
    this.error = props.error
    this.message = props.message
    this.path = props.path
    this.status = props.status
    this.timestamp = props.timestamp
  }
}
